import { useEffect } from "react";
import { InputFocusBlue } from "../../Utils/Constant";
import { isValidUrl } from "../../Utils/Helper";
import { useGetCitationDescription } from "../../Web-Hooks/LibraryAPI/use-citation";
import LoadingSpinner from "../UI/LoadingSpinner";
import EditableBodyPopup from "./EditableBodyPopup";

const CitationPopup = ({
  popupOpen,
  setPopupOpen,
  selectedCitation = {
    citationUrl: "",
    citationNote: "",
    citationType: "",
    citationTitle: "",
  },
  setSelectedCitation,
  handleSubmit,
  isFromExternalCitation = false,
  isUploadCitationPending,
  isEdit,
  heading,
}) => {
  const handleClose = () => {
    setSelectedCitation({
      citationUrl: "",
      citationNote: "",
      citationType: "",
      citationTitle: "",
    });
    setPopupOpen(false);
  };

  const isValid = isValidUrl(selectedCitation?.citationUrl);

  const {
    data: urlData,
    isLoading: isCitationLoading,
    status,
  } = useGetCitationDescription(isValid ? selectedCitation?.citationUrl : "");

  useEffect(() => {
    if (status === "success" && isFromExternalCitation) {
      setSelectedCitation({
        ...selectedCitation,
        citationTitle: urlData?.title,
        citationType: "url",
      });
    } // eslint-disable-next-line
  }, [status, isFromExternalCitation]);

  const isFromExternalValidateUrl = isFromExternalCitation
    ? !isValidUrl(selectedCitation?.citationUrl)
    : false;

  const handleChange = (e) => {
    setSelectedCitation({
      ...selectedCitation,
      citationUrl: e.target.value,
      citationTitle: e.target.value === "" ? "" : urlData?.title,
    });
  };

  return (
    <div>
      <EditableBodyPopup
        size="sm"
        btn1={"Close"}
        title={heading === "Add Reference" ? heading : "Add Citation"}
        handleClose={handleClose}
        open={popupOpen}
        btn2={isEdit ? "Update" : "Attach"}
        onClickBtn1={handleClose}
        onClickBtn2={handleSubmit}
        loading={isUploadCitationPending}
        disableBtn={!selectedCitation?.citationUrl || isFromExternalValidateUrl}
      >
        <div className="flex flex-col gap-4 w-full justify-center items-center">
          <div className="flex flex-col gap-2 w-full">
            <input
              id="citation-heading"
              type="text"
              disabled={!isFromExternalCitation}
              className={`border-2 rounded-md p-2 mt-1 block w-full text-debatePalette-title !border-debatePalette-shadow focus:outline-none ${InputFocusBlue}`}
              placeholder="Enter your url here."
              value={
                isFromExternalCitation
                  ? selectedCitation?.citationUrl
                  : selectedCitation?.citationTitle
              }
              readOnly={isEdit}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col min-w-full">
            {isCitationLoading ? (
              <LoadingSpinner type={"ThreeDots"} color={"#1F455D"} />
            ) : (
              <>
                {isFromExternalCitation && (
                  <div className="flex flex-col gap-2 w-full">
                    <input
                      id="citation-title"
                      type="text"
                      className={`border-2 rounded-md p-2 mt-1 block w-full text-debatePalette-title !border-debatePalette-shadow focus:outline-none ${InputFocusBlue}`}
                      placeholder="Enter your title here"
                      value={selectedCitation?.citationTitle}
                      onChange={(e) =>
                        setSelectedCitation({
                          ...selectedCitation,
                          citationTitle: e.target.value,
                        })
                      }
                      readOnly={isEdit}
                    />
                  </div>
                )}
                <textarea
                  name="citation-notes"
                  type="text"
                  rows={3}
                  className={`border-2 text-debatePalette-title font-medium rounded-md !border-debatePalette-shadow p-2 mt-1 focus:outline-none block w-full ${InputFocusBlue}`}
                  placeholder="Write a note to attach to your debate"
                  value={selectedCitation?.citationNote}
                  onChange={(e) =>
                    setSelectedCitation({
                      ...selectedCitation,
                      citationNote: e.target.value,
                    })
                  }
                />
              </>
              // <RichTextarea
              //   id="citation-text"
              //   type="text"
              //   rows={3}
              //   className={`border-2  rounded-md !border-debatePalette-shadow p-2 mt-1 focus:outline-none block min-w-full ${InputFocusBlue}`}
              //   placeholder="Write a note to attach to your debate, this note will
              //       not be displayed"
              //   style={{ width: "100%" }}
              //   value={selectedCitation?.citationNote}
              //   onChange={(e) =>
              //     setSelectedCitation({
              //       ...selectedCitation,
              //       citationNote: e.target.value,
              //     })
              //   }
              // >
              //   {renderer}
              // </RichTextarea>
            )}
          </div>
        </div>
      </EditableBodyPopup>
    </div>
  );
};

export default CitationPopup;
